import { DEAL_PERIOD_EXPERIMENT } from '../../constants/experiments';
import { TAbUseExperimentsState } from '../../types/abUseExperiments';
import { TAddressField } from '../FormContainer/types';
import { IGeoFormValue } from '../GeoContainer/types';

export enum ELocationIds {
  MOSCOW = 1,
  SPB = 2,
}

const isTypeAddressField = (address: TAddressField | IGeoFormValue): address is TAddressField => {
  return 'address' in address;
};

// В зависимости от типа объявления разное расположения locationId
export const getLocationId = (address: TAddressField | IGeoFormValue) => {
  return isTypeAddressField(address) ? address.locationId : address.location?.id;
};

export const isDealPeriodExperiment = (abUseExperiments: TAbUseExperimentsState) => {
  const experiment = abUseExperiments.find(({ experimentName }) => experimentName === DEAL_PERIOD_EXPERIMENT);

  return experiment?.groupName === 'enabled';
};
